export default "__VITE_ASSET__444f0711__"